import * as React from "react";

// 画面上の要素を短時間に連続タップしたときだけ発動する隠し操作。
// 直近 windowMs 以内のタップ数が count に達した時点で onTrigger を1回呼び、数え直す。
// 間が空いたタップは数えないため、通常の操作で偶然に発動することはまずない。
// 発動した回のタップも含めて数え直すので、連打を続けても1回の発動につき count 回のタップが要る。
export const useHiddenTapTrigger = (count: number, windowMs: number, onTrigger: () => void): (() => void) => {
  const tapsRef = React.useRef<number[]>([]);
  const onTriggerRef = React.useRef(onTrigger);
  onTriggerRef.current = onTrigger;

  return React.useCallback(() => {
    const now = Date.now();
    const taps = tapsRef.current.filter((tappedAt) => now - tappedAt < windowMs);
    taps.push(now);
    if (taps.length < count) {
      tapsRef.current = taps;
      return;
    }
    tapsRef.current = [];
    onTriggerRef.current();
  }, [count, windowMs]);
};
